import Cookies from 'js-cookie'
import moment from 'moment'

export default {
  methods: {
    setChildBirthdayCookie (date, index) {
      Cookies.set(`child_birthday_${index}`, moment(date).format('DD.MM.YYYY'), {
        expires: 180,
      })
    },
    getChildBirthdayCookie (index) {
      return Cookies.get(`child_birthday_${index}`)
    },
    childBirthdayCookieExist (index) {
      return Cookies.get(`child_birthday_${index}`)       
    },
  },
}


// WEBPACK FOOTER //
// ./src/components/search/ChildBirthdayAsCookieMixin.js